import React, { Fragment, cloneElement, useRef, useState, useEffect } from 'react';

export function LinksButton({ label, iconSrc, svgSrc, svgProps = {}, noTranslate = false }) {
  const svgRef = useRef(null);
  const [topAria, setTopAria] = useState(label || '');

  useEffect(() => {
    let el = svgRef.current;
    if (!el) return undefined;

    const initial = el.getAttribute && el.getAttribute('aria-label');
    if (initial) setTopAria(initial);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'aria-label') {
          const v = el.getAttribute('aria-label');
          setTopAria(v || '');
        }
      }
    });

    observer.observe(el, { attributes: true, attributeFilter: ['aria-label'] });

    return () => observer.disconnect();
  }, [svgRef.current]);

  const SvgElement = (() => {
        if (!svgSrc) return null;
        if (React.isValidElement(svgSrc)) return cloneElement(svgSrc, svgProps);
        if (typeof svgSrc === 'function') {
            const Cmp = svgSrc;
            return <Cmp {...svgProps} />;
        }

        return null;
    })();

    return (
        <Fragment>
             <svg class={noTranslate ? "notranslate" : ""} ref={svgRef} width="320" height="60" viewBox="0 0 320 60" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={label}>
               <g filter="url(#filter0_d_19_3)">
                 <path d="M4 26C4 11.6406 15.6406 0 30 0H290C304.359 0 316 11.6406 316 26C316 40.3594 304.359 52 290 52H30C15.6406 52 4 40.3594 4 26Z" fill="white" />
               </g>

               <foreignObject x="0" y="0" width="320" height="52">
                 <div xmlns="http://www.w3.org/1999/xhtml" style={{ color: 'black', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                   {iconSrc ? ( <img src={iconSrc} alt="" /> ) : SvgElement }
                   <div style={{ fontSize: 20, fontFamily: 'Montserrat-Medium, sans-serif' }}>{topAria}</div>
                 </div>
               </foreignObject>

               <defs>
                 <filter id="filter0_d_19_3" x="0" y="0" width="320" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                   <feFlood floodOpacity="0" result="BackgroundImageFix" />
                   <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                   <feOffset dy="4" />
                   <feGaussianBlur stdDeviation="2" />
                   <feComposite in2="hardAlpha" operator="out" />
                   <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                   <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19_3" />
                   <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_19_3" result="shape" />
                 </filter>
               </defs>
             </svg>
        </Fragment>
    );
}
